import React from "react";
import { useState, useEffect } from "react";
import { Col, Row } from "antd";
import { getReportesFilter_request } from "../services/reportes_sevices";
import { Layout } from "antd";

//importacion de scss
import "../pages/styles/Reportes.scss";

import { Loader } from "../componentes/GeneralComponents/Loader";

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import NewNavbar from "../componentes/GeneralComponents/Navbar_Nuevo";
import SummaryCards from "../componentes/reportes-components/summaryCards";
import { formatCurrency, getChartData } from "../utils/report-filters";
import { ChartCard } from "../componentes/reportes-components/chartCard";
import { EgresosBreakdown } from "../componentes/reportes-components/egresosBreakdown";
import { IngresosBreakdown } from "../componentes/reportes-components/ingresosBreakdown";
import { StatsCard } from "../componentes/reportes-components/statsCard";
import { FilterBar } from "../componentes/reportes-components/filterBar";
import { getGraphData_request, getMovimientosFilter_request } from "../services/IngresosyEgresos_services";
import { formatear, getFechaActual } from "../utils/utils";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const { Header, Footer, Sider, Content } = Layout;

function Reportes() {
  const location = useLocation();
  const [IngresoTotal, setIngresoTotal] = useState(0);
  const [EgresoTotal, setEgresoTotal] = useState(0);
  const [Balance, setBalance] = useState(0);
  const [Citas, setCitas] = useState({ Citas: 0 });
  const [Consultas, setConsultas] = useState({
    Consulta: "0",
    NumeroConsulta: "0",
  });
  const [Recetas, setRecetas] = useState({
    Receta: "0",
    NumeroReceta: 0,
  });
  const [IngresosList, setIngresosList] = useState([]);
  const [EgresosList, setEgresosList] = useState([]);
  const [EgresosPorCategoria, setEgresosPorCategoria] = useState([]);
  const [EgresosItems, setEgresosItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [typeMessage, setTypeMessage] = useState("");
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);

  const [selectedPeriod, setSelectedPeriod] = useState('day');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [chartData, setChartData] = useState([]);

  const getPeriodLabel = () => {
    switch (selectedPeriod) {
      case 'day':
        return 'Hoy';
      case 'month':
        return 'Este mes';
      case 'year':
        return 'Este año';
    }
  };

  async function getReportesFilter(dates) {
    setLoader(true);

    let data = new FormData();
    data.append("FechaInicio", dates.inicio);
    data.append("FechaFin", dates.fin);

    let response = await getReportesFilter_request(4, data);
    if (response.ok) {
      setIngresoTotal(response.data.movimientos.ingresos);
      setEgresoTotal(response.data.movimientos.egresos);
      setBalance(response.data.movimientos.ingresos - response.data.movimientos.egresos);
      setConsultas(response.data.Consultas);
      setRecetas(response.data.Recetas);
      setCitas(response.data.Citas);
    } else {
      setIngresoTotal(0);
      setEgresoTotal(0);
      setBalance(0);
      setConsultas({
        Consulta: "0",
        NumeroConsulta: "0",
      });
      setRecetas({
        Receta: "0",
        NumeroReceta: 0,
      });
      setCitas({ Citas: 0 });
      setOpen(true);
      setTypeMessage("error");
      setMessage(response.mensaje);
    }
    setLoader(false);
    return;
  }

  async function getGraphData(dates, period) {
    const data = {
      "FechaInicio": dates.inicio,
      "FechaFin": dates.fin
    }

    let response = await getGraphData_request(data);
    if (response.ok) {
      let data = procesarMovimientos(response.data.ingresos, response.data.egresos, period);
      console.log(data);
      console.log(response.data.ingresos);
      console.log(response.data.egresos);


      setChartData(data);
      setIngresosList(response.data.ingresos);
      setEgresosList(response.data.egresos);


      // return response.data;
    } else {
      setChartData([]);
      setIngresosList([]);
      setEgresosList([]);
      setOpen(true);
      setTypeMessage("error");
      setMessage(response.mensaje);
    }
    return;
  }

  const procesarMovimientos = (ingresos, egresos, filtro) => {
    let resultado = [];

    const getHora = (fecha) => parseInt(fecha.split(' ')[1].split(':')[0]);
    const getDia = (fecha) => parseInt(fecha.split(' ')[0].split('-')[2]);
    const getMes = (fecha) => parseInt(fecha.split(' ')[0].split('-')[1]) - 1;

    // FILTRO POR DIA

    if (filtro === 'day') {
      const rangos = [
        '0:00-3:00', '3:00-6:00', '6:00-9:00', '9:00-12:00',
        '12:00-15:00', '15:00-18:00', '18:00-21:00', '21:00-24:00'
      ];

      resultado = rangos.map(r => ({
        name: r,
        ingresos: 0,
        egresos: 0
      }));

      const getIndex = (hora) => Math.floor(hora / 3);
      if (ingresos.length > 0) {
        ingresos.forEach(i => {
          resultado[getIndex(getHora(i.fecha))].ingresos += parseFloat(i.cantidad);
        });
      }

      if (egresos.length > 0) {
        egresos.forEach(e => {
          resultado[getIndex(getHora(e.fecha))].egresos += parseFloat(e.cantidad);
        });
      }
    }

    // FILTRO POR MES

    if (filtro === 'month') {
      const getDia = (fecha) => parseInt(fecha.split(' ')[0].split('-')[2]);
      const getMes = (fecha) => parseInt(fecha.split(' ')[0].split('-')[1]) - 1;
      const getYear = (fecha) => parseInt(fecha.split(' ')[0].split('-')[0]);

      // Tomamos una fecha de referencia (puede ser el primer ingreso o egreso) pero validamos antes que no esten vacios
      let fechaBase;

      if (ingresos.length > 0) {
        fechaBase = ingresos[0].fecha;
      } else if (egresos.length > 0) {
        fechaBase = egresos[0].fecha;
      } else {
        fechaBase = getFechaActual();
      }

      const year = getYear(fechaBase || "");
      const mes = getMes(fechaBase);

      // Obtener cuántos días tiene el mes (28,29,30,31)
      const diasEnMes = new Date(year, mes + 1, 0).getDate();

      // const semanas = [];

      for (let i = 1; i <= diasEnMes; i += 7) {
        const inicio = i;
        const fin = Math.min(i + 6, diasEnMes);

        resultado.push({
          name: `${inicio}-${fin}`,
          ingresos: 0,
          egresos: 0
        });
      }

      const getSemanaIndex = (dia) => Math.floor((dia - 1) / 7);

      if (ingresos.length > 0) {
        ingresos.forEach(i => {
          const index = getSemanaIndex(getDia(i.fecha));
          resultado[index].ingresos += parseFloat(i.cantidad);
        });
      }

      if (egresos.length > 0) {
        egresos.forEach(e => {
          const index = getSemanaIndex(getDia(e.fecha));
          resultado[index].egresos += parseFloat(e.cantidad);
        });
      }

    }

    // FILTRO POR AÑO
    if (filtro === 'year') {
      const meses = [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];

      resultado = meses.map(m => ({
        name: m,
        ingresos: 0,
        egresos: 0
      }));

      ingresos.forEach(i => {
        resultado[getMes(i.fecha)].ingresos += parseFloat(i.cantidad);
      });

      egresos.forEach(e => {
        resultado[getMes(e.fecha)].egresos += parseFloat(e.cantidad);
      });
    }

    return resultado;
  };


  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: location.pathname,
    });
    getReportesFilter({ inicio: formatear(selectedDate), fin: formatear(selectedDate) }).then(() => getGraphData({ inicio: formatear(selectedDate), fin: formatear(selectedDate) }, selectedPeriod));
  }, []);

  return (
    <Stack>

      <NewNavbar
        mensajesError={{
          setOpen: setOpen,
          setTypeMessage: setTypeMessage,
          setMessage: setMessage,
        }}
        modulo={"Reportes"}
        searchBar={
          <div
            style={{
              display: "flex",

              background: "white",
              padding: "1% 3%",
              alignItems: "center",
            }}
          >
            <FilterBar
              selectedPeriod={selectedPeriod}
              onPeriodChange={setSelectedPeriod}
              selectedDate={selectedDate}
              onDateChange={setSelectedDate}
              filterReports={getReportesFilter}
              graphData={getGraphData}
            />
          </div>
        }
      />

      <Content
        className="site-layout"
        style={{
          padding: "1% 3%",
          width: "100%",
          overflow: "initial",
        }}
      >
        {loader ? (
          <Loader />
        ) : (
          <div className="contenedorprinR">

            <SummaryCards
              cards={[
                {
                  title: 'Ingresos Totales',
                  value: formatCurrency(IngresoTotal),
                  change: '+12.5%',
                  trend: 'up',
                  icon: 'income'
                },
                {
                  title: 'Egresos Totales',
                  value: formatCurrency(EgresoTotal),
                  change: '+5.2%',
                  trend: 'down',
                  icon: 'expense'
                },
                {
                  title: 'Balance',
                  value: formatCurrency(Balance),
                  change: Balance >= 0 ? 'Positivo' : 'Negativo',
                  trend: Balance >= 0 ? 'up' : 'down',
                  icon: 'balance'
                },
                {
                  title: 'Consultas',
                  value: Consultas.NumeroConsulta,
                  icon: 'activity'
                }
              ]}
            />

            {/* <div className="contenedorR">
              <div className="contenedorCharts">
                <ChartCard
                  title="Comparación Ingresos vs Egresos"
                  data={chartData}
                  type="bar"
                  dataKeys={[
                    { key: 'ingresos', name: 'Ingresos', color: '#10b981' },
                    { key: 'egresos', name: 'Egresos', color: '#ef4444' }
                  ]}
                />
              </div>

              <div className="contenedorCharts">
                <ChartCard
                  title="Tendencia de Flujo de Efectivo"
                  data={chartData}
                  type="line"
                  dataKeys={[
                    { key: 'ingresos', name: 'Ingresos', color: '#10b981' },
                    { key: 'egresos', name: 'Egresos', color: '#ef4444' }
                  ]}
                />

              </div>

            </div> */}

            <Row className="contenedorR">
              {/* <Col span={12}> */}
              <div className="contenedorCharts">
                <IngresosBreakdown
                  porConsulta={parseFloat(Consultas.Consulta)}
                  porRecetas={parseFloat(Recetas.Receta)}
                />
              </div>
              {/* </Col> */}

              {/* <Col span={12}> */}
              {/* {Object.keys(EgresosPorCategoria).length > 0 && (
                  <EgresosBreakdown porCategoria={EgresosPorCategoria} />
                )} */}
              <div className="contenedorCharts">
                <ChartCard
                  title="Comparación Ingresos vs Egresos"
                  data={chartData}
                  type="bar"
                  dataKeys={[
                    { key: 'ingresos', name: 'Ingresos', color: '#10b981' },
                    { key: 'egresos', name: 'Egresos', color: '#ef4444' }
                  ]}
                />
              </div>
              {/* </Col> */}
            </Row>

            <Row className="contenedorR">
              {/* <Col span={8}> */}
              <div className="contenedorStatsCard">

                <StatsCard
                  title={`Ingresos - ${getPeriodLabel()}`}
                  items={[
                    { label: 'Totales', value: formatCurrency(IngresoTotal) },
                    { label: 'Por consulta', value: formatCurrency(parseFloat(Consultas.Consulta)) },
                    { label: 'Por recetas', value: formatCurrency(parseFloat(Recetas.Receta)) },
                  ]}
                />
              </div>

              {/* </Col> */}

              {/* <Col span={8}> */}
              <div className="contenedorStatsCard">

                <StatsCard
                  title={`Actividad - ${getPeriodLabel()}`}
                  items={[
                    { label: 'No. de citas', value: Citas.Citas },
                    { label: 'No. de consultas', value: Consultas.NumeroConsulta },
                    { label: 'Recetas enviadas', value: Recetas.NumeroReceta },
                  ]}
                />
              </div>

              {/* </Col> */}

              {/* <Col span={8}> */}
              <div className="contenedorStatsCard">

                <StatsCard
                  title={`Egresos - ${getPeriodLabel()}`}
                  items={[
                    { label: "Total", value: formatCurrency(parseFloat(EgresoTotal)) }
                  ].concat(EgresosItems)}
                />
              </div>

              {/* </Col> */}
            </Row>
          </div>
        )}
      </Content>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={typeMessage}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}

export default Reportes;
